import { useState, useEffect } from 'react';
export default function useIntersectionObserver({
  ref,
  unmountAfterIntersection = false,
  disabled = false,
  options
}) {
  const [didIntersect, setDidIntersect] = useState(false);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);
  useEffect(() => {
    if (!ref.current || disabled || !mounted) {
      return () => {};
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === ref.current && entry.isIntersecting) {
          setIsIntersecting(true);
          setDidIntersect(true);
          if (unmountAfterIntersection) {
            observer.unobserve(ref.current);
          }
        }
        if (entry.target === ref.current && !entry.isIntersecting) {
          setIsIntersecting(false);
        }
      });
    }, options);
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, unmountAfterIntersection, disabled, mounted, options]);
  return {
    isIntersecting,
    didIntersect
  };
}
//# sourceMappingURL=useIntersectionObserver.js.map